import PropTypes from 'prop-types';
import { useState, useEffect, useCallback } from 'react';
import { debounce } from 'lodash';
import { styled, alpha } from '@mui/material/styles';
import { OutlinedInput, InputAdornment } from '@mui/material';
import Iconify from '../../components/iconify';

// ----------------------------------------------------------------------

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: '100%',
  maxWidth: 'min(440px, 100%)',
  boxSizing: 'border-box',
  transition: theme.transitions.create(['box-shadow'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {
    boxShadow: theme.customShadows.z8,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

// ----------------------------------------------------------------------

SearchBar.propTypes = {
  onSearch: PropTypes.func.isRequired,
  value: PropTypes.string,
};

export default function SearchBar({ onSearch, value = '' }) {
  const [searchTerm, setSearchTerm] = useState(value);

  useEffect(() => {
    setSearchTerm(value);
  }, [value]);
  /* eslint-disable react-hooks/exhaustive-deps */
  const debouncedSearch = useCallback(
    debounce((searchValue) => {
      onSearch(searchValue);
    }, 500),
    [onSearch]
  );

  useEffect(() => {
    debouncedSearch(searchTerm);
    return () => debouncedSearch.cancel();
  }, [searchTerm, debouncedSearch]);

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <StyledSearch
      value={searchTerm}
      onChange={handleChange}
      placeholder="Search..."
      startAdornment={
        <InputAdornment position="start">
          <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
        </InputAdornment>
      }
    />
  );
}
